"use client";
import React from "react";
import cn from "classnames";

import PropTypes from "prop-types";

import VideoBgBase from "./video-bg-base/VideoBgBase";

const VideoBg = ({ block, showSendUsMessage, isFirst = false }) => {
  const { productId, desktop, mobile } = block;
  return (
    <div>
      {!desktop.hide && (
        <VideoBgBase
          className={cn("hide-tablet")}
          isFirst={isFirst}
          block={{ ...desktop, productId }}
          showSendUsMessage={showSendUsMessage}
        />
      )}
      {!mobile.hide && (
        <VideoBgBase
          className={cn("hide-desktop")}
          isFirst={isFirst}
          isMobile
          block={{ ...mobile, productId }}
          showSendUsMessage={showSendUsMessage}
        />
      )}
    </div>
  );
};

VideoBg.propTypes = {
  block: PropTypes.shape({
    desktop: PropTypes.shape({}),
    mobile: PropTypes.shape({}),
    productId: PropTypes.string,
  }).isRequired,
  showSendUsMessage: PropTypes.func.isRequired,
  isFirst: PropTypes.bool,
};

export default VideoBg;
